import React, { useEffect } from "react";

import { StartActivity, sleep } from "../../../../common/common";
import * as omnimap from "../../../../../api/omnimap/omnimapActions";
import * as CallBackFunctions from "../functions/callBackFunctions";
import $ from "jquery";
import {MAN_PL_CONST} from "../../../../../constants/ActionEnums/ManActionEnums";
import {GetSelected} from "../../../../common/tableHandler/manipulateTable";
import {InitiateProcessAction} from "../../../../../api/omnimap/omnimapActions";

const WijzigStatus = () => {
  useEffect(async () => {
    $("#wijzig_status").on("show.bs.modal", async function (event) {
      var selectedIds = [];

      $("#example")
        .dataTable()
        .$("tr.selected")
        .each(function () {
          selectedIds.push($(this).attr("rowId"));
        });
      let result = await omnimap.GetActivityDefinitionAction(
        selectedIds[0],
        "3a98846b-67c1-4192-9edc-b980f10898b8",
        window.$mm_management_units_token
      );

      CallBackFunctions.WijzigStatusCallback(result, "wijzig-status-grp");
    });
  });

  const handleSubmit = () => {
    const element = $("input[name=wijzig-status]:checked");
    if(element.length > 0) {
      $("#cover-spin").show(0);
      const label = element[0].defaultValue;
      // const model = { status: label };
      // var selectedIds = [];
      // $("#example")
      //   .dataTable()
      //   .$("tr.selected")
      //   .each(function () {
      //     selectedIds.push($(this).attr("rowId"));
      //   });

      // StartActivity(
      //   model,
      //   selectedIds,
      //   "3a98846b-67c1-4192-9edc-b980f10898b8",
      //   WijzigStatusSaved,
      //   window.$mm_management_units_token
      // );

      const model = {
        "action": MAN_PL_CONST.CHANGE_STATUS,
        "werkregel_status": label,
        "identifications": GetSelected()
      }


      InitiateProcessAction(model, MAN_PL_CONST.END_POINT).then(()=>{

        $("#wijzig_status").modal("hide");
        window.$mm_schedule_tableReload();

      }).catch(()=>{
        alert('Something went wrong!')
        $("#cover-spin").hide(0);
      })
    } else {
      alert("je moet kiezen");
    }
  };
  const WijzigStatusSaved = () => {
    sleep(900).then(() => {
      $("#wijzig_status").modal("hide");
      window.$mm_schedule_tableReload();
      /*omnimap
        .FillTableAction(
          window.$mm_schedule_lastUsedTableFilter,
          1,
          window.$mm_management_units_token
        )
        .then((result) => {
          CallBackFunctions.FillTableCallBack(result, 1);
        });*/
    });
  };

  return (
    <div className="modal fade" tabIndex={-1} role="dialog" id="wijzig_status">
      <div className="modal-dialog" role="document">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Wijzig status</h5>
            <button
              type="button"
              className="close"
              data-dismiss="modal"
              aria-label="Close"
            />
          </div>
          <div className="modal-body">
            <input type="search" className="modal-search" placeholder="" />
            <div className="modal-scroll">
              <div id="wijzig-status-grp" className="radio-grp" />
            </div>
          </div>
          <div className="modal-footer">
            <button
              type="button"
              id="save_wijzig_status"
              className="btn-modal"
              onClick={handleSubmit}
            >
              Verwerken
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WijzigStatus;
